import React from "react";
import styles from "./MyAssetsCards.module.css";
import copyInnerImg from "../static_files/copy inner.svg";
import copyConfirmMobileImg from "../static_files/copyConfirmMobile.png";
import shareInnerImg from "../static_files/share inner.svg";

function BalanceCard({
  title = "Balance",
  balance,
  usdValue,
  apyLabel,
  apyValue,
  navPerUsdi,
  cumulativeInterest,
  accruedInterest,
  isLoading,
  justCopied,
  onCopy,
  onShare,
  usdiTokenAddress,
}) {
  const showBalance = !isLoading && balance != null && balance !== "" && balance !== "--";
  const balanceNum = parseFloat(balance);
  const hasBalance = showBalance && !Number.isNaN(balanceNum) && balanceNum > 0;
  const hasCumulativeValue =
    cumulativeInterest != null &&
    Number.isFinite(Number(cumulativeInterest)) &&
    Number(cumulativeInterest) !== 0;
  const cumulativeDisplay = hasCumulativeValue
    ? Number(cumulativeInterest).toLocaleString("en-US", { maximumFractionDigits: 2 })
    : "—";

  return (
    <div className={styles.card}>
      <h3 className={styles.cardTitle}>{title}</h3>
      <div className={styles.balanceGrid}>
        <div className={styles.balanceTokenInfo}>
          <div className={styles.balanceAssetIcon}>U</div>
          <div>
            <div className={styles.balanceAssetName}>USDi</div>
          </div>
          <div className={styles.balanceIcons}>
            <img
              src={justCopied ? copyConfirmMobileImg : copyInnerImg}
              alt={justCopied ? "Copied" : "Copy"}
              width={16}
              height={16}
              onClick={onCopy}
              style={{ cursor: "pointer" }}
            />
            <img
              src={shareInnerImg}
              alt="Share"
              width={16}
              height={16}
              onClick={() => onShare?.(usdiTokenAddress)}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <div className={styles.balanceTokenBalance}>
          {isLoading ? (
            <>
              <span className={styles.balanceAmountPlaceholder} aria-hidden="true" />
              <span className={styles.balanceUsdPlaceholder} aria-hidden="true" />
            </>
          ) : (
            <>
              <div className={styles.balanceAmount}>
                {hasBalance ? Number(balanceNum).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "—"}
              </div>
              {usdValue != null && hasBalance && (
                <div className={styles.balanceUsd}>=${Number(usdValue).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
              )}
            </>
          )}
        </div>
        <div className={styles.balanceApyWrap}>
          <div className={styles.balanceApyValue}>
            {isLoading ||
            apyValue == null ||
            !Number.isFinite(Number(apyValue)) ||
            Number(apyValue) === 0 ? (
              <span className={styles.balanceAmountPlaceholder} aria-hidden="true" />
            ) : (
              `${Number(apyValue).toFixed(2)}%`
            )}
          </div>
          <div className={styles.balanceApyLabel}>
            Current APY <span className={styles.balanceApyNote}>30-Day Avg</span>
          </div>
        </div>
      </div>
      <div className={styles.balanceStatsRow}>
        <div className={styles.balanceStat}>
          <div className={styles.balanceStatValue}>
            {isLoading || navPerUsdi == null || !Number.isFinite(Number(navPerUsdi)) ? (
              <span className={styles.balanceStatPlaceholder} aria-hidden="true" />
            ) : (
              Number(navPerUsdi).toFixed(2)
            )}
          </div>
          <div className={styles.balanceStatLabel}>NAV per USDi</div>
        </div>
        <div className={styles.balanceStat}>
          <div className={styles.balanceStatValue}>
            {isLoading || !hasCumulativeValue ? (
              <span className={styles.balanceStatPlaceholder} aria-hidden="true" />
            ) : (
              <>
                {cumulativeDisplay}
                <span> USDi</span>
              </>
            )}
          </div>
          <div className={styles.balanceStatLabel}>Cumulative Interest</div>
        </div>
        <div className={styles.balanceStat}>
          <div className={styles.balanceStatValue}>
            {isLoading ||
            accruedInterest == null ||
            !Number.isFinite(Number(accruedInterest)) ||
            Number(accruedInterest) === 0 ? (
              <span className={styles.balanceStatPlaceholder} aria-hidden="true" />
            ) : (
              <>
                {Number(accruedInterest).toLocaleString("en-US", { maximumFractionDigits: 2 })}
                <span> USDi</span>
              </>
            )}
          </div>
          <div className={styles.balanceStatLabel}>Accrued Interest</div>
        </div>
      </div>
    </div>
  );
}

export default BalanceCard;
